module.exports = __webpack_public_path__ + "static/media/snoopybigmoon.b03a6759.webp";